// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__eMPWq","Loading_move__yG63v":"Spinner_Loading_move__yG63v__M+lJM"};